import { useEffect, useState } from 'react';
import {
  COMPACT_PWA_LANDSCAPE_QUERY,
  COMPACT_PWA_WIDTH_QUERY,
  getPwaViewportState,
} from '../utils/pwaViewport';

export function useCompactPwaViewport(isStandalone = false) {
  const [state, setState] = useState(() => getPwaViewportState({ isStandalone }));

  useEffect(() => {
    const update = () => setState(getPwaViewportState({ isStandalone }));
    update();

    const widthQuery = window.matchMedia?.(COMPACT_PWA_WIDTH_QUERY);
    const landscapeQuery = window.matchMedia?.(COMPACT_PWA_LANDSCAPE_QUERY);
    widthQuery?.addEventListener?.('change', update);
    landscapeQuery?.addEventListener?.('change', update);
    window.addEventListener('resize', update);
    window.addEventListener('orientationchange', update);
    window.visualViewport?.addEventListener?.('resize', update);

    return () => {
      widthQuery?.removeEventListener?.('change', update);
      landscapeQuery?.removeEventListener?.('change', update);
      window.removeEventListener('resize', update);
      window.removeEventListener('orientationchange', update);
      window.visualViewport?.removeEventListener?.('resize', update);
    };
  }, [isStandalone]);

  return state;
}
